<button (click)="login()">Login</button>
<button (click)="logout()">Logout</button>